var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("booking-menu-with-budget-header", {
        attrs: {
          title: _vm.$t("booking.flight.title"),
          "budget-type": "flight"
        }
      }),
      _c("v-row"),
      _c("booking-flight-data-table")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }